export default __webpack_public_path__ + "static/media/Gloves of the Revelations.2ff662d4.jpg";